import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthenticationGuardService} from './services/authentication-guard.service';
import {MainContainerComponent} from './pages/main-container/main-container.component';
import {MainContainerModule} from './pages/main-container/main-container.module';
import {MainContainerResolver} from './resolvers/main-container-resolver';
import {ErrorPageComponent} from './pages/error-page/error-page.component';
import {PageNotFoundComponent} from './pages/page-not-found/page-not-found.component';

const routes: Routes =
[
  {
    path: '',
    redirectTo: '/main-container/home',
    pathMatch: 'full'
  },
  {
    path: 'main-container',
    component: MainContainerComponent,
    canActivate: [AuthenticationGuardService],
    resolve: {emisoresCFEsDTOs: MainContainerResolver},
    children:
    [
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'emision-cfe',
        loadChildren: () => import('./pages/emision-cfe/emision-cfe.module').then(m => m.EmisionCfeModule)
      },
      {
        path: 'cfes-emitidos',
        loadChildren: () => import('./pages/cfes-emitidos/cfes-emitidos.module').then(m => m.CfesEmitidosModule)
      },
      {
        path: 'receptores',
        loadChildren: () => import('./pages/receptores/receptores.module').then(m => m.ReceptoresModule)
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'home'
      }
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule
({
  imports: [RouterModule.forRoot(routes), MainContainerModule],
  exports: [RouterModule],
  providers: [AuthenticationGuardService]
})
export class AppRoutingModule
{

}
